import { render, staticRenderFns } from "./AamsGiftRegInStorageDetail.vue?vue&type=template&id=7e857151&scoped=true&"
import script from "./AamsGiftRegInStorageDetail.vue?vue&type=script&lang=js&"
export * from "./AamsGiftRegInStorageDetail.vue?vue&type=script&lang=js&"
import style0 from "./AamsGiftRegInStorageDetail.vue?vue&type=style&index=0&id=7e857151&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7e857151",
  null
  
)

export default component.exports